import type { StateCreator } from "zustand";
import type { DraftStoreState, LineDraftHeader } from "./types";

export const createHeaderSlice: StateCreator<
  DraftStoreState,
  [],
  [],
  Pick<DraftStoreState, "setHeader">
> = (set) => ({
  setHeader: (patch: Partial<LineDraftHeader>) =>
    set((state) => ({
      header: { ...state.header, ...patch },
      dirty: true,
    })),
});
